<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="my-3">
  <h2 *ngIf="this.status ==='create'">Add Repair Record</h2>
  <h2 *ngIf="this.status ==='edit'">Edit Repair Record</h2>
</div>


<div [ngClass]="!loading ? 'block' : 'hidden'">
  <section id="breakdownDetails">
    <nz-card>
      <div>
        <h5 class="text-primary">Breakdown Details</h5>
        <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8">

          <div>

            <form nz-form [formGroup]="repairsForm">

              <div class="grid sm:grid-cols-2 gap-3" formGroupName="breakdownDetails">
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="breakdownDate" nzRequired>Breakdown Date</nz-form-label>
                  <nz-form-control [nzErrorTip]="breakdownDate">
                    <nz-date-picker formControlName="breakdownDate"
                                    class="w-full" [ngModel]="currentDate"></nz-date-picker>
                  </nz-form-control>
                  <ng-template #breakdownDate>
                    <span *ngIf="formErrors.breakdownDetails.breakdownDate.required">Please select Date </span>
                  </ng-template>
                </nz-form-item>

                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="repairDoneBy" nzRequired>Repair Done By</nz-form-label>
                  <nz-form-control [nzErrorTip]="repairDoneBy">
                    <nz-select formControlName="repairDoneBy" nzPlaceHolder="Select">
                      <nz-option nzValue="SR" nzLabel="SR"></nz-option>
                      <nz-option *ngIf="fleetData.generalInformation.vehicleType !== 'SR'" nzValue="Vehicle Owner" nzLabel="Vehicle Owner"></nz-option>
                      <nz-option nzValue="Rental Customer" nzLabel="Rental Customer"></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #repairDoneBy>
                    <span *ngIf="formErrors.breakdownDetails.repairDoneBy.required">Please select Who the Repair was done by. </span>
                  </ng-template>
                </nz-form-item>

                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="issueType" nzRequired>Select Issue Type</nz-form-label>
                  <nz-form-control [nzErrorTip]="issueType">
                    <nz-select formControlName="issueType" [nzShowArrow]="true" nzPlaceHolder="Select" nzMode="multiple" >
                      <nz-option nzValue="Suspensions" nzLabel="Suspensions"></nz-option>
                      <nz-option nzValue="Engine" nzLabel="Engine"></nz-option>
                      <nz-option nzValue="Breaks" nzLabel="Breaks"></nz-option>
                      <nz-option nzValue="ABS" nzLabel="ABS"></nz-option>
                      <nz-option nzValue="Gear Box" nzLabel="Gear Box"></nz-option>
                      <nz-option nzValue="A/C" nzLabel="A/C"></nz-option>
                      <nz-option nzValue="Electrical Malfunction" nzLabel="Electrical Malfunction"></nz-option>
                      <nz-option nzValue="Radiator" nzLabel="Radiator"></nz-option>
                      <nz-option nzValue="Water Pump" nzLabel="Water Pump"></nz-option>
                      <nz-option nzValue="Accident" nzLabel="Accident"></nz-option>
                      <nz-option nzValue="Other" nzLabel="Other"></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #issueType>
                    <span *ngIf="formErrors.breakdownDetails.issueType.required">Please select Issue Type. </span>
                  </ng-template>
                </nz-form-item>


                <nz-form-item class="grid grid-flow-row content-start"
                              *ngIf="this.repairsForm.get('breakdownDetails.issueType').value.includes('Other')">
                  <nz-form-label nzFor="otherIssue">Specify Other Issue</nz-form-label>
                  <nz-form-control [nzErrorTip]="otherIssue">
                    <input nz-input type="text" [maxLength]="150" formControlName="otherIssue"
                           nzPlaceHolder="Enter Issue"/>
                  </nz-form-control>
                  <ng-template #otherIssue>
                    <span *ngIf="formErrors.breakdownDetails.otherIssue.required">Please enter Issue</span>
                  </ng-template>
                </nz-form-item>

              </div>
            </form>
          </div>

          <div>
            <form nz-form [formGroup]="repairsForm">
              <div formGroupName="breakdownDetails">
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="otherIssue">Notes</nz-form-label>
                  <nz-form-control>
                  <textarea rows="6" formControlName="notesBreakdown" nz-input
                            PlaceHolder="Enter notes here"></textarea>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </form>
          </div>
        </div>
      </div>
    </nz-card>
  </section>


  <section id="repairInformation" class="mt-10"
  >
    <nz-card>
      <div>
        <h5 class="text-primary">Repair Information</h5>
        <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8">

          <div>
            <form nz-form [formGroup]="repairsForm">

              <div class="grid sm:grid-cols-2 gap-3" formGroupName="repairInformation">

                <nz-form-item class="grid grid-flow-row content-start" *ngIf="this.repairsForm.get('breakdownDetails.repairDoneBy').value === 'Rental Customer'">
                  <nz-form-label nzFor="partsReplacedByCustomer" nzRequired>Parts Replaced By Customer</nz-form-label>
                  <nz-form-control [nzErrorTip]="partsReplacedByCustomer">
                    <nz-input-group>
                      <nz-select
                        [nzMaxTagCount]="8"
                        [nzMaxTagPlaceholder]="tagPlaceHolder"
                        [nzShowArrow]="nzShowArrow"
                        nzMode="multiple"
                        nzPlaceHolder="Please select"
                        formControlName="partsReplacedByCustomer"
                        nzrequired
                      >

                        <nz-option *ngFor="let item of listOfOption" [nzLabel]="item" [nzValue]="item"></nz-option>
                      </nz-select>
                    </nz-input-group>
                    <ng-template #tagPlaceHolder let-selectedList>and {{ selectedList.length }} more selected
                    </ng-template>
                  </nz-form-control>
                  <ng-template #partsReplacedByCustomer>
                    <span *ngIf="formErrors.repairInformation.partsReplacedByCustomer.required">Please the parts replaced by the customer</span>
                  </ng-template>
                </nz-form-item>

                <nz-form-item class="grid grid-flow-row content-start"
                              *ngIf="this.repairsForm.get('repairInformation.partsReplacedByCustomer').value.includes('Other')">
                  <nz-form-label nzFor="otherParts">Specify Other Parts</nz-form-label>
                  <nz-form-control [nzErrorTip]="otherParts">
                    <input nz-input type="text" formControlName="otherParts" nzPlaceHolder="Specify Other Parts"/>
                  </nz-form-control>
                  <ng-template #otherParts>
                    <span *ngIf="formErrors.repairInformation.otherParts.required">Please Specify Other Parts </span>
                  </ng-template>
                </nz-form-item>
              </div>
            </form>
          </div>
        </div>

        <div>
          <form nz-form [formGroup]="repairsForm">
            <div class="mt-5 grid md:grid-cols-2 xl:grid-cols-4 gap-3" formGroupName="repairInformation">

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="repairStartDate" nzRequired>Repair Start Date</nz-form-label>
                <nz-form-control [nzErrorTip]="repairStartDate">
                  <nz-date-picker formControlName="repairStartDate" [ngModel]="currentDate" class="w-full" nzRequired
                  ></nz-date-picker>
                </nz-form-control>
                <ng-template #repairStartDate>
                <span
                  *ngIf="formErrors.repairInformation.repairStartDate.required">Please Enter repair start date.</span>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="repairEndDate" nzRequired>Projected Repair End Date</nz-form-label>
                <nz-form-control [nzErrorTip]="repairEndDate">
                  <nz-date-picker formControlName="repairEndDate" [ngModel]="currentDate" class="w-full" nzRequired
                  ></nz-date-picker>
                </nz-form-control>
                <ng-template #repairEndDate>
                  <span *ngIf="formErrors.repairInformation.repairEndDate.required">Please Enter repair end date.</span>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="actualRepairStartDate">Actual Repair End Date</nz-form-label>
                <nz-form-control [nzErrorTip]="actualRepairStartDate">
                  <nz-date-picker formControlName="actualRepairStartDate"
                                  class="w-full"></nz-date-picker>
                </nz-form-control>
                <ng-template #actualRepairStartDate>
        <span
          *ngIf="formErrors.repairInformation.actualRepairStartDate.required">Please Enter Actual repair start date. </span>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="backToFleetDate">Back To Fleet Date</nz-form-label>
                <nz-form-control [nzErrorTip]="backToFleetDate">
                  <nz-date-picker formControlName="backToFleetDate"
                                  class="w-full"></nz-date-picker>
                </nz-form-control>
                <ng-template #backToFleetDate>
        <span
          *ngIf="formErrors.repairInformation.backToFleetDate.required">Please Enter Actual repair end date. </span>
                </ng-template>
              </nz-form-item>
            </div>
          </form>
        </div>

        <div>
          <form nz-form [formGroup]="repairsForm">
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-3" formGroupName="repairInformation">

              <div>
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="notesInformation">Notes</nz-form-label>
                  <nz-form-control>
                  <textarea class="hidden xl:block" rows="8" formControlName="notesInformation" nz-input
                            PlaceHolder="Enter Notes here"></textarea>
                      <textarea class="block xl:hidden" rows="5" formControlName="notesInformation" nz-input
                                PlaceHolder="Enter Notes here"></textarea>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div>
                <p class="pb-[11px] font-normal">Attachments</p>

                <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-[8.5rem] xl:h-52 py-2">
                  <div>
                    <nz-upload
                      [nzCustomRequest]="repairUpload" [nzShowUploadList]="false" [nzMultiple]="false">
                      <button nz-button>
                        <span nz-icon nzType="upload"></span>
                        Click to Upload
                      </button>
                    </nz-upload>
                  </div>
                  <div>
                    <p *ngIf="repairUploading" class="text-primary my-2">Uploading...</p>
                  </div>
                  <div class="mt-2 overflow-auto">
                    <div *ngFor="let file of repairFiles; let i = index"
                         class="flex justify-between items-center mx-3 gap-5">
                      <a target="_blank" href="{{file.url}}">{{file.name}}</a>
                      <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'" [nzTwotoneColor]="'#ff0000'"
                            class="cursor-pointer" nz-popconfirm
                            nzPopconfirmTitle="Are you sure you want to delete this attachment"
                            (nzOnConfirm)="confirmRemoveAttachmentRepair(i)"
                      ></span>
                    </div>
                  </div>
                </div>

                <!--              <nz-upload [nzCustomRequest]="repairUpload" [nzShowUploadList]="false" [nzMultiple]="false"-->
                <!--                         class="flex justify-center items-center bg-slate-100 w-full h-32 xl:h-48">-->
                <!--                <button nz-button>-->
                <!--                  <span nz-icon nzType="upload"></span>-->
                <!--                  Click to Upload-->
                <!--                </button>-->
                <!--              </nz-upload>-->
                <!--              <div *ngFor="let file of repairFiles; let i = index">-->
                <!--                <a class="" target="_blank" href="{{file.url}}">{{file.name}} <span nz-icon nzType="close" nz-popconfirm-->
                <!--                                                                                    nzPopconfirmTitle="Are you sure you want to delete the attachment"-->
                <!--                                                                                    nzPopconfirmPlacement="bottom"-->
                <!--                                                                                    (nzOnConfirm)="confirmRemoveAttachmentRepair(i)"-->
                <!--                                                                                    (nzOnCancel)="cancel()"-->
                <!--                                                                                    nzTheme="outline"></span></a>-->
                <!--              </div>-->
              </div>


            </div>
          </form>
        </div>


      </div>
    </nz-card>
  </section>


  <section id="paymentDetails" class="mt-10">
    <nz-card>
      <div>
        <h5 class="text-primary">Payment Details</h5>
        <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8">

          <div>
            <form nz-form [formGroup]="repairsForm">

              <div class="grid sm:grid-cols-2 gap-3" formGroupName="paymentDetails">

                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="paymentDoneBy" nzRequired>Payment Done By</nz-form-label>
                  <nz-form-control [nzErrorTip]="paymentDoneBy">
                    <nz-select
                      nzPlaceHolder="Please select"
                      formControlName="paymentDoneBy"
                    >
                      <nz-option nzLabel="SR" nzValue="SR"></nz-option>
                      <nz-option nzLabel="Customer" nzValue="Customer"></nz-option>
                      <nz-option nzLabel="Vehicle Owner" nzValue="Vehicle Owner" *ngIf="this.fleetData.generalInformation.vehicleType !== 'SR'"></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #paymentDoneBy>
                    <span *ngIf="formErrors.paymentDetails.paymentDoneBy.required">Please select who the payment was done by </span>
                  </ng-template>
                </nz-form-item>

                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="totalCost" nzRequired>Total Repair Cost</nz-form-label>
                  <nz-form-control [nzErrorTip]="totalCost">
                    <nz-input-number
                      class="w-full"
                      formControlName="totalCost"
                      nzPlaceHolder="Enter Total cost"
                      [nzMin]="0"
                      [nzStep]="1"
                      [nzFormatter]="formatterCurrencyMonthRent"
                      [nzParser]="parserCurrencyMonthRent"
                    ></nz-input-number>
                  </nz-form-control>
                  <ng-template #totalCost>
                    <span *ngIf="formErrors.paymentDetails.totalCost.required">Enter Total Cost </span>
                  </ng-template>
                </nz-form-item>
              </div>
            </form>
          </div>
        </div>

        <div>
          <form nz-form [formGroup]="repairsForm">
            <div class="mt-5 grid md:grid-cols-2 xl:grid-cols-4 gap-3" formGroupName="paymentDetails">

              <nz-form-item class="grid grid-flow-row content-start"
                            *ngIf="this.repairsForm.get('paymentDetails.paymentDoneBy').value === 'Vehicle Owner'">
                <nz-form-label nzFor="repaymentType" nzRequired>Repayment Type</nz-form-label>
                <nz-form-control [nzErrorTip]="repaymentType">
                  <nz-select formControlName="repaymentType" nzPlaceHolder="Select">
                    <nz-option nzValue="Reimbursement From Owner" nzLabel="Reimbursement From Owner"></nz-option>
                    <nz-option nzValue="Rental Deduction" nzLabel="Rental Deduction"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #repaymentType>
                  <span
                    *ngIf="formErrors.paymentDetails.repaymentType.required">Please Enter Repayment Type</span>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start"
                            *ngIf="this.repairsForm.get('paymentDetails.paymentDoneBy').value === 'Vehicle Owner'">
                <nz-form-label nzFor="installments" nzRequired>Enter Installments</nz-form-label>
                <nz-form-control [nzErrorTip]="installments">
                  <nz-select formControlName="installments" nzRequired nzPlaceHolder="Select">
                    <nz-option nzValue="YES" nzLabel="Yes"></nz-option>
                    <nz-option nzValue="NO" nzLabel="No"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #installments>
                  <span
                    *ngIf="formErrors.paymentDetails.installments.required">Please Enter the Installments </span>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start"
                            *ngIf="this.repairsForm.get('paymentDetails.installments').value === 'YES'">
                <nz-form-label nzFor="installmentPeriod" nzRequired>Installment Period</nz-form-label>
                <nz-form-control [nzErrorTip]="installmentPeriod">
                  <input nz-input type="number" formControlName="installmentPeriod" nzPlaceHolder="Installment Period"/>
                </nz-form-control>
                <ng-template #installmentPeriod>
        <span
          *ngIf="formErrors.paymentDetails.installmentPeriod.required">Please Enter Installment Period</span>
                </ng-template>
              </nz-form-item>

            </div>
          </form>
        </div>

        <div>
          <form nz-form [formGroup]="repairsForm">
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-3" formGroupName="paymentDetails">

              <div>
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="otherIssue">Notes</nz-form-label>
                  <nz-form-control>
                  <textarea class="hidden xl:block" rows="8" formControlName="notesPayments" nz-input
                            PlaceHolder="Enter notes here"></textarea>
                      <textarea class="block xl:hidden" rows="5" formControlName="notesPayments" nz-input
                                PlaceHolder="Enter notes here"></textarea>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div>
                <p class="pb-[10px]">Attachments</p>

                <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-[8.5rem] xl:h-52 py-2">
                  <div>
                    <nz-upload
                      [nzCustomRequest]="paymentUpload" [nzShowUploadList]="false" [nzMultiple]="false">
                      <button nz-button>
                        <span nz-icon nzType="upload"></span>
                        Click to Upload
                      </button>
                    </nz-upload>
                  </div>
                  <div>
                    <p *ngIf="paymentUploading" class="text-primary my-2">Uploading...</p>
                  </div>
                  <div class="mt-2 overflow-auto">
                    <div *ngFor="let file of paymentFiles; let i = index"
                         class="flex justify-between items-center mx-3 gap-5">
                      <a target="_blank" href="{{file.url}}">{{file.name}}</a>
                      <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'" [nzTwotoneColor]="'#ff0000'"
                            class="cursor-pointer" nz-popconfirm
                            nzPopconfirmTitle="Are you sure you want to delete this attachment"
                            (nzOnConfirm)="confirmRemoveAttachment(i)"
                      ></span>
                    </div>
                  </div>
                </div>

                <!--              <nz-upload [nzCustomRequest]="paymentUpload" [nzShowUploadList]="false" [nzMultiple]="false"-->
                <!--                         class="flex justify-center items-center bg-slate-100 w-full h-32 xl:h-48">-->
                <!--                <button nz-button>-->
                <!--                  <span nz-icon nzType="upload"></span>-->
                <!--                  Click to Upload-->
                <!--                </button>-->
                <!--              </nz-upload>-->
                <!--              <div *ngFor="let file of paymentFiles; let i = index">-->
                <!--                <a class="" target="_blank" href="{{file.url}}">{{file.name}} <span nz-icon nzType="close" nz-popconfirm-->
                <!--                                                                                    nzPopconfirmTitle="Are you sure you want to delete the attachment"-->
                <!--                                                                                    nzPopconfirmPlacement="bottom"-->
                <!--                                                                                    (nzOnConfirm)="confirmRemoveAttachment(i)"-->
                <!--                                                                                    (nzOnCancel)="cancel()"-->
                <!--                                                                                    nzTheme="outline"></span></a>-->
                <!--              </div>-->
              </div>


            </div>
          </form>
        </div>


      </div>
    </nz-card>
  </section>

  <section id="buttons" class="mt-6">
    <nz-card>
      <div class="flex justify-end sm:justify-end">
        <a
          nz-popconfirm
          nzPopconfirmTitle="Are you sure you want to cancel this record? you will loose all data."
          nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="confirm()"
          (nzOnCancel)="cancel()"
        >
          <button class="outline-button mr-3" nz-button nzType="default">Cancel</button>
        </a>
        <button nz-button nzType="primary" nz-popconfirm
                nzPopconfirmTitle="Are you sure you want to save this record?"
                [nzOkText]="'Yes'" [nzCancelText]="'No'" *ngIf="this.status === 'create'" (nzOnConfirm)="onSubmit()"
                [disabled]="this.repairsForm.invalid">Add Record
        </button>
        <button nz-button nzType="primary" nz-popconfirm
                nzPopconfirmTitle="Are you sure you want to Update this record?"  [nzOkText]="'Yes'" [nzCancelText]="'No'"
                *ngIf="this.status === 'edit'" (nzOnConfirm)="onUpdate()"
                [disabled]="this.repairsForm.invalid">Update Record
        </button>
      </div>
    </nz-card>
  </section>
</div>
<div [ngClass]="loading ? 'block' : 'hidden'">
  <app-edit-view-skeleton-template></app-edit-view-skeleton-template>
</div>

